var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "172.54 269.63 678.91 478.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M172.544 508.827c0-154.652 19.131-185.893 36.169-202.931 26.714-26.714 65.945-36.264 303.287-36.264 237.342 0 276.573 9.55 303.287 36.264 17.038 17.038 36.02 48.036 36.168 201.125 0 153.089-19.064 187.633-36.168 204.738-26.714 26.713-65.945 36.263-303.287 36.263-237.342 0-276.573-9.55-303.287-36.263-17.104-17.105-36.169-48.279-36.169-202.932z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.049 509.404l-177.245 100.99v-201.98l177.245 100.99z",
    className: "svg-fill--inverse"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e272d1ca4789d5534376cb7014158e38.svg";
export { ForwardRef as ReactComponent };